/**
 * Parse query parameters according to https://refeds.org/specifications/errorurl-v1
 * @param query The query parameters
 * @returns errorURL data
 */
export function parseErrorURL(query) {
    const code = query.get("code");
    const ts = query.get("ts");
    const rp = query.get("rp");
    const tid = query.get("tid");
    const ctx = query.get("ctx");
    let parsedDate;
    if (ts && ts !== "ERRORURL_TS") {
        // Convert unix time stamp to a Date object
        parsedDate = new Date(Number.parseInt(ts) * 1000);
    }
    /* An SP that doesn't understand one or more of the parameters will leave them unchanged from the template
     * in the SWAMID metadata, which is why we check them all against the template values before returning them.
     */
    return {
        code: code && code !== "ERRORURL_CODE" ? code : undefined,
        ts: ts && ts !== "ERRORURL_TS" ? ts : undefined,
        rp: rp && rp !== "ERRORURL_RP" ? rp : undefined,
        tid: tid && tid !== "ERRORURL_TID" ? tid : undefined,
        ctx: ctx && ctx !== "ERRORURL_CTX" ? ctx : undefined,
        date: parsedDate,
    };
}
